/**
 * PasswordResetRoute — router-level dispatcher for `/password-reset`.
 *
 * The email link in `apps/api/src/modules/identity/infrastructure/email/
 * smtp-email.renderer.ts:102` is shaped as
 * `${FE_URL}/password-reset?token=…`, so both the request flow (no
 * token) and the consume flow (with token) share a single FE path.
 * This dispatcher reads `?token` and selects:
 *
 *   - PasswordResetConsumePage when a token is present (the consume
 *     page itself validates the 64-hex format and falls through to its
 *     "invalid link" surface on bad input)
 *   - PasswordResetPage otherwise (the email request form)
 *
 * Keeping the dispatch at the router boundary leaves each leaf page
 * with a single responsibility and a token-as-prop seam that tests
 * exercise without MemoryRouter setup.
 */

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { PasswordResetPage } from './PasswordResetPage.js';
import { PasswordResetConsumePage } from './PasswordResetConsumePage.js';

export function PasswordResetRoute(): React.ReactElement {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  if (token !== null && token.length > 0) {
    return <PasswordResetConsumePage token={token} />;
  }
  return <PasswordResetPage />;
}
